<div class="bottom-sheet">
    <div class="content-box">
      <img src="https://commondatastorage.googleapis.com/images.5paisa.com/SPOT/Rectangle.svg" alt="Loading Image" />
      <div class="text-content">
        <div class="title">Hang Tight!</div>
        <span class="subtitle">
          We’re redirecting you to <b class="finbox">{{vendorType.toLowerCase()}}</b><br>for fetching your bank statement
        </span>
      </div>
    </div>
</div>